module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1716370112122,
}